// Run this example by adding <%= javascript_pack_tag 'hello_erb' %> to the head of your layout file,
// like app/views/layouts/application.html.erb. Don't forget to uncomment erb tag after adding it to your layout file.

import '/tmp/build_80c85a83/vendor/bundle/ruby/3.2.0/gems/rails-timeago-2.20.0/vendor/assets/javascripts/jquery.timeago.js';
